import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { palette } from "styled-theme";
import { isEmpty } from "ramda";

import { materialType } from "~/constants/prop-types";

import DragAndDropEntry from "../DragAndDropEntry";

import List from "@mui/material/List";
import ListSubheader from "@mui/material/ListSubheader";

import { MATERIAL_ITEM_TYPE } from "~/constants/dnd-types";
import { useDrop } from "react-dnd";

const StyledSubheader = styled(ListSubheader)`
  background-color: ${palette("mbgreen", 1)} !important;
  line-height: 32px !important;
`;

const listStyle = { padding: 0 };

const NonAssignedMaterialsList = ({ onClickHandler, materials, activePages, onDrop }) => {
  const [{}, dropTarget] = useDrop({
    accept: MATERIAL_ITEM_TYPE,
    drop: onDrop
  });

  function onClick(material) {
    return onClickHandler({
      id: material._id,
      page: -1,
      renderType: material.renderType,
      type: material.type
    });
  }

  return isEmpty(materials) ? null : (
    <div ref={dropTarget}>
      <StyledSubheader key="//TODO: REPLACE KEY" disableSticky={true}>
        Nicht zugeordnet
      </StyledSubheader>
      <div>
        <List style={listStyle}>
          {materials.map(material => {
            if (material.notInSidebar) return null;
            return (
              <DragAndDropEntry
                activePages={activePages}
                key={material._id}
                material={material}
                onHandleClick={onClick(material)}
              />
            );
          })}
        </List>
      </div>
    </div>
  );
};

NonAssignedMaterialsList.propTypes = {
  materials: PropTypes.arrayOf(materialType).isRequired,
  onClickHandler: PropTypes.func.isRequired,
  activePages: PropTypes.array,
  onDrop: PropTypes.func.isRequired
};

export default NonAssignedMaterialsList;
